export default __webpack_public_path__ + "static/media/icon4.292f116e.svg";